/**
 * HTTP client minimale per l'API del server.
 *
 * Usa fetch con headers JSON e gestisce errori 4xx/5xx restituendo un oggetto
 * { ok, data, error } invece di throw, per semplificare il gestionale UI.
 * Include sempre le credenziali (cookie di sessione).
 */

const BASE = import.meta.env.VITE_API_URL || '/api';

async function request(path, options = {}) {
  const url = BASE + (path.startsWith('/') ? path : '/' + path);
  const defaultHeaders = { 'Content-Type': 'application/json' };
  const opts = {
    headers: { ...defaultHeaders, ...options.headers },
    ...options,
  };
  const res = await fetch(url, { credentials: 'include', ...opts });
  let json;
  try { json = await res.json(); } catch {}

  if (!res.ok) {
    return { ok: false, status: res.status, error: json?.error || res.statusText, raw: json };
  }
  return { ok: true, status: res.status, data: json };
}

async function upload(path, body, options = {}) {
  const url = BASE + (path.startsWith('/') ? path : '/' + path);
  const opts = {
    method: 'POST',
    body,
    ...options,
  };
  const res = await fetch(url, { credentials: 'include', ...opts });
  let json;
  try { json = await res.json(); } catch {}

  if (!res.ok) {
    return { ok: false, status: res.status, error: json?.error || res.statusText, raw: json };
  }
  return { ok: true, status: res.status, data: json };
}

export const api = {
  get:      (path, init) => request(path, { ...init, method: 'GET' }),
  post:     (path, body, init) => request(path, { ...init, method: 'POST', body: JSON.stringify(body) }),
  put:      (path, body, init) => request(path, { ...init, method: 'PUT', body: JSON.stringify(body) }),
  patch:    (path, body, init) => request(path, { ...init, method: 'PATCH', body: JSON.stringify(body) }),
  del:      (path, init)     => request(path, { ...init, method: 'DELETE' }),
  upload,
};

export default api;
